const AppFooter = () => {
    return (
        <div className="layout-footer">
            <img width={128} src={'/img/teklense-logo-lg.jpg'} alt="jobvritta" />
            <span className="copyright">&#169; ats.teklense.com - {new Date().getFullYear()}</span>
        </div>
    );
};

export default AppFooter;
